import PersonVoiceoverIcon from '@atlaskit/icon-lab/core/person-voiceover';
import React from 'react';

export function SvgPronunciation() {
  return <PersonVoiceoverIcon label="" testId="ads-refreshed-icon" />;
}
